import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const authToken = {
  get: () => localStorage.getItem("elite_admin_token"),
  set: (t) => localStorage.setItem("elite_admin_token", t),
  clear: () => localStorage.removeItem("elite_admin_token"),
};

api.interceptors.request.use((config) => {
  const t = authToken.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const AMENITY_LABELS = {
  pool: "Pool", hot_tub: "Hot Tub", lakefront: "Lakefront", family: "Family Friendly",
  pet: "Pet Friendly", luxury: "Luxury", game_room: "Game Room", fire_pit: "Fire Pit",
  events: "Weddings & Events", riverfront: "Riverfront", acreage: "5 Private Acres",
  gated: "Gated", parking: "Ample Parking", watersports: "Kayaks & SUPs",
  community_pool: "Community Pool", new_braunfels: "Great New Braunfels Location",
  boutique: "Boutique", medical_center: "Medical Center", boat_parking: "Boat Parking",
  cozy: "Cozy, Unique Stay", grill: "Grill", acreage8: "8 Private Acres",
};
